document.addEventListener("click", (e) => {
  const drawer = e.target.closest(".cart-drawer");
  let counter = 0;
  const interval = setInterval(() => {
    let element = BSS_B2B.observer.cartSubject;
    if (element) {
          BSS_B2B.observer.cartSubject.notifyObserver('CartUpdate', 'CartMutate');
        clearInterval(interval);
    } else {
        counter += 100;
        if (counter >= 10000) {
            clearInterval(interval);
        }
    }
}, 100); 
});

document.addEventListener("click", (e) => {
  const input = e.target.closest("input[data-current-checked]");

  if (!input) return;

  const currentChecked = input.getAttribute("data-current-checked");

  if (currentChecked === "true") return;

  setTimeout(() => {
  document.dispatchEvent(new Event("bss_b2b:QuickviewLoaded"));
    
  }, 800);

});


window.bssB2BHooks = window.bssB2BHooks || {
  actions: {},
  filters: {},
};
window.BSS_B2B = window.BSS_B2B || {};
window.BSS_B2B.addAction = (tag, callback) => {
  window.bssB2BHooks.actions[tag] = callback;
};
window.BSS_B2B.addFilter = (tag, value) => {
  window.bssB2BHooks.filters[tag] = value;
};
function customModalTitle() {
    document.querySelector(".cart-drawer__close-button")?.dispatchEvent?.(new Event("click"));
    return "Order must contain total";
}
window.BSS_B2B.addFilter('custom:ol/modalTitle', customModalTitle); 


function handleSearchTrigger() {
    window.dispatchEvent(new Event("scroll"));
}

document.addEventListener("DOMContentLoaded", () => {
    const inputSearchSelector = "input.search-input";
    let debounceTimer;

    document.addEventListener("input", (e) => {
        if (e.target && e.target.matches(inputSearchSelector)) {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => {
                handleSearchTrigger();
            }, 300);
        }
    });
});

document.addEventListener("click", (e) => {
    if (e.target.closest(".search-modal__button")) {
        handleSearchTrigger();
    }
});

const isPDP = window.location.pathname.includes("/products/");
if (isPDP) {
    let oldHref = location.href;
    new MutationObserver(() => {
        if (oldHref !== location.href) {
            oldHref = location.href;
            const variant = new URL(location.href).searchParams.get('variant');
                console.log("ACTIVE")
                const productForm = document.querySelector('[bss-b2b-main-product-form]');
                const priceEl = productForm.querySelector('[bss-b2b-product-price]');

                if (priceEl) {
                  priceEl.style.visibility = 'visible !important';
                }
                console.log("PRICEEL: ",priceEl)
                setTimeout(() => {
                    const productForm = document.querySelector("[bss-b2b-main-product-form]");
                    BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {productForm});
                },700)
        }
    }).observe(document, {
        subtree: true,
        childList: true
    });
} 